import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

export const MY_PROFILE_QUERY_KEY = ['my-profile'] as const;

/** The signed-in person's own profile (name + email), shared by every page. */
export function useMyProfile() {
  return useQuery({
    queryKey: MY_PROFILE_QUERY_KEY,
    queryFn: api.getMyProfile,
    staleTime: 5 * 60_000,
  });
}
